module.exports = __webpack_public_path__ + "img/hr-ccm-belt-04b-sequence-shadow.4e96750b.png";